import Box from 'components/atomic/atoms/box'
import Text from 'components/atomic/atoms/text'
import SharedTwitterWall from 'components/pages/@shared/twitter-wall'
import TemplateCodeExamples, {
  TemplateCodeExampleProps,
} from 'components/pages/frameworks/@shared/template/template.code-examples'
import TemplateHero, {
  TemplateHeroProps,
} from 'components/pages/frameworks/@shared/template/template.hero'
import TemplateStartBuilding, {
  TemplateStartBuildingProps,
} from 'components/pages/frameworks/@shared/template/template.start-building'

type Props = {
  hero: TemplateHeroProps
  codeExamples: TemplateCodeExampleProps
  startBuilding: TemplateStartBuildingProps
}

const SharedTemplate = (props: Props) => {
  return (
    <>
      <Box
        css={{ spaceY: 16, container: 'xl', '@md': { spaceY: 32, pb: '$18' } }}
      >
        <Box css={{ spaceY: 14, '@md': { spaceY: 32 } }}>
          <TemplateHero {...props.hero} />
          <TemplateCodeExamples {...props.codeExamples} />
          <Box css={{ spaceY: 10, '@md': { container: 'lg' } }}>
            <Text
              as="h2"
              size={{ '@initial': '3xl', '@md': '4xl' }}
              weight="semiBold"
              align="center"
            >
              Testimonials
            </Text>
            <SharedTwitterWall />
          </Box>
          <TemplateStartBuilding {...props.startBuilding} />
        </Box>
      </Box>
    </>
  )
}

export default SharedTemplate
